import { render, staticRenderFns } from "./EditVariantInOrder.vue?vue&type=template&id=1fc512aa&"
import script from "./EditVariantInOrder.vue?vue&type=script&lang=js&"
export * from "./EditVariantInOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports